import {TokenService as Service} from '../TokenService';

import {useDialogCrup} from '../../../../shared/hooks/DialogCrup';
import {useTranslation} from '../../../../shared/language';

export const Crup = ({header, dataKey, refreshLazyData}) => {
  const {t} = useTranslation();

  const {render, create, update, setValue} = useDialogCrup({
    header,
    dataKey,
    width: '60rem',
    fields: [
      {field: 'vender', header: t('common.certificateProvider'), type: 'InputTextarea', disabled: true, className: 'md:col-12'},
      {field: 'subjectName', header: t('common.certificateOwner'), type: 'InputTextarea', disabled: true, className: 'md:col-12'},
      {field: 'serialNumber', header: t('report.certificateSerial'), disabled: true, className: 'md:col-12'},
      {field: 'dateFrom', header: t('report.validFrom'), type: 'Calendar', disabled: true, className: 'md:col-6'},
      {field: 'expireDate', header: t('report.expirationDate'), type: 'Calendar', disabled: true, className: 'md:col-6'},
      {field: 'form', header: t('common.tokenRegistrationForm'), type: 'Dropdown', DropdownProps: {options: Service.forms}, disabled: true, className: 'md:col-6'},
      {field: 'tokenType', header: t('common.certificateType'), type: 'Dropdown', DropdownProps: {options: Service.tokenTypes}, disabled: true, className: 'md:col-6'},
      {field: 'used', header: t('catalog.emailUsage'), type: 'Checkbox', className: 'md:col-6'},
      {field: 'defaultSign', header: t('common.defaultSign'), type: 'Checkbox', className: 'md:col-6'}
    ],
    defaultValue: {
      used: true
    },
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  return {render, create, update, setValue};

}
